var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlaylistLight = function SvgPlaylistLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#F3F3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.75,
    y: 10.75,
    width: 138.5,
    height: 138.5,
    rx: 69.25,
    stroke: "#F3F3F8",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 126,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "playlist-light_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 24,
    width: 160,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 24c-20.728 0-38.825 11.262-48.508 28H30c-5.523 0-10 4.477-10 10v36c0 5.523 4.477 10 10 10h21.492c9.683 16.738 27.78 28 48.508 28s38.826-11.262 48.508-28H170c5.523 0 10-4.477 10-10V62c0-5.523-4.477-10-10-10h-21.492c-9.682-16.738-27.78-28-48.508-28Z",
    fill: "red"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#playlist-light_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#F3F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 55.5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 52.75,
    width: 54.5,
    height: 54.5,
    rx: 9.25,
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.793 86.055c-1.337.8-3.034-.168-3.027-1.725l.04-8.675c.008-1.554 1.707-2.507 3.036-1.702l7.19 4.352c1.29.78 1.284 2.654-.01 3.427l-7.23 4.323Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.25,
    y: 99.25,
    width: 22.75,
    height: 3.5,
    rx: 1.75,
    fill: "#E7E5F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.5,
    y: 55.5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.75,
    y: 52.75,
    width: 54.5,
    height: 54.5,
    rx: 9.25,
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.793 86.055c-1.337.8-3.034-.168-3.027-1.725l.04-8.675c.008-1.554 1.707-2.507 3.036-1.702l7.189 4.352c1.29.78 1.285 2.654-.009 3.427l-7.229 4.323Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.25,
    y: 99.25,
    width: 22.75,
    height: 3.5,
    rx: 1.75,
    fill: "#E7E5F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.125,
    y: 45.875,
    width: 78,
    height: 78,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.75,
    y: 41.75,
    width: 76.5,
    height: 76.5,
    rx: 9.25,
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.73 89.15c-1.336.798-3.033-.17-3.026-1.727l.068-14.862c.007-1.554 1.707-2.507 3.036-1.702l12.317 7.456c1.29.781 1.285 2.654-.009 3.428L95.73 89.149Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.313,
    y: 106.812,
    width: 31.688,
    height: 4.875,
    rx: 2.438,
    fill: "#E7E5F1"
  }))));
};

export { SvgPlaylistLight as ReactComponent };
export default "data:image/svg+xml;base64,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";